import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { HttpService } from '../http.service';
import * as moment from 'moment';

@Component({
  selector: 'app-that-year',
  templateUrl: './that-year.component.html',
  styleUrls: ['./that-year.component.css']
})
export class ThatYearComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpService) {

  }

  udate: string = "";

  sum: number = 0;
  sum2: number = 0;

  money: Object;

  clickRow(udate) {
    this.router.navigate(['/ThatMonth'], { queryParams: { udate: udate } });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe((value) => {
      if (value['udate'] == null) {
        this.router.navigate(['/ThatYear'], { queryParams: { udate: moment().format("yyyy") } });
        return;
      }
      else {
        this.udate = value['udate'];

        document.getElementById("pnLoading").style.display = "block";

        this.http.getThatYear(this.udate).subscribe(res => {

          if (res.code === 200) {
            this.money = res.money;

            res.money.map((mn, i) => {
              this.sum += parseInt(mn.sum);
              this.sum2 += parseInt(mn.sum2);
            });
          }
          else if (res.code == 401) {
            this.http.logout();
          }
          else {
            alert('系統錯誤');
          }

          document.getElementById("pnLoading").style.display = "none";

        },
          err => {
            alert(err.error)
            document.getElementById("pnLoading").style.display = "none";
          });
      }
    });

  }

}
